import { i18NextMixinFactory } from "@apphq/vue-base-components";

export default i18NextMixinFactory(
  "lib-user-profile",
  { en: require("./en") },
  "de"
);
